"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentListQueryOrderDirectionEnum = exports.ContentListQueryOrderFieldEnum = void 0;
exports.ContentListQueryOrderFromJSON = ContentListQueryOrderFromJSON;
exports.ContentListQueryOrderFromJSONTyped = ContentListQueryOrderFromJSONTyped;
exports.ContentListQueryOrderToJSON = ContentListQueryOrderToJSON;
exports.ContentListQueryOrderToJSONTyped = ContentListQueryOrderToJSONTyped;
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var ContentListQueryOrderFieldEnum;
(function (ContentListQueryOrderFieldEnum) {
    ContentListQueryOrderFieldEnum["ReleaseDate"] = "release_date";
    ContentListQueryOrderFieldEnum["Views"] = "views";
    ContentListQueryOrderFieldEnum["Priority"] = "priority";
    ContentListQueryOrderFieldEnum["Topn"] = "topn";
    ContentListQueryOrderFieldEnum["Title"] = "title";
})(ContentListQueryOrderFieldEnum || (exports.ContentListQueryOrderFieldEnum = ContentListQueryOrderFieldEnum = {})); /**
* @export
* @enum {string}
*/
var ContentListQueryOrderDirectionEnum;
(function (ContentListQueryOrderDirectionEnum) {
    ContentListQueryOrderDirectionEnum["Asc"] = "asc";
    ContentListQueryOrderDirectionEnum["Desc"] = "desc";
    ContentListQueryOrderDirectionEnum["Random"] = "random";
})(ContentListQueryOrderDirectionEnum || (exports.ContentListQueryOrderDirectionEnum = ContentListQueryOrderDirectionEnum = {}));
function ContentListQueryOrderFromJSON(json) {
    return ContentListQueryOrderFromJSONTyped(json, false);
}
function ContentListQueryOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'field': !(0, runtime_1.exists)(json, 'field') ? undefined : json['field'],
        'direction': json['direction'],
    };
}
function ContentListQueryOrderToJSON(value) {
    return ContentListQueryOrderToJSONTyped(value, false);
}
function ContentListQueryOrderToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field': value.field,
        'direction': value.direction,
    };
}
